export const modalReservationDirect = {
  header: {
    title: "Reservas diretas pela web",
    subtitle: "Defina o que o hóspede vê e como as regras se aplicam.",
  },
  tabs: {
    reservations: "Status da reserva",
    ratePlans: "Tarifas",
    promotions: "Promoções",
    addons: "Cobranças adicionais",
    payments: "Preços e pagamentos",
    share: "Compartilhar",
  },
  common: {
    close: "Fechar",
    updating: "Atualizando…",
    hotel: "Hotel",
    apartment: "Apartamento",
    visible: "Visível",
    default: "Padrão",
    dragToReorder: "Arraste para reordenar",
    saving: "Salvando…",
    preview: "Prévia",
  },
  toast: {
    successTitle: "Sucesso",
  },
  save: {
    ratePlans: "Salvar tarifas",
    promotions: "Salvar promoções",
    addons: "Salvar cobranças",
    default: "Salvar",
  },
  reservations: {
    cardTitle: "Status das reservas diretas",
    cardDesc: "Ative ou desative a disponibilidade de reservas diretas (globalmente e por unidade).",
    activateTitle: "Ativar reservas diretas",
    activateHelp: "Se isto estiver desativado, você não pode ativar unidades individuais.",
    colName: "Acomodação / Unidade",
    colCapacity: "Capacidade",
    colAvailable: "Disponível",
    emptyUnits: "Nenhuma unidade configurada para esta propriedade.",
  },
  ratePlans: {
    title: "Tarifas exibidas na Reserva Direta",
    hotelDesc: "Defina quais tarifas são exibidas para cada tipo de quarto",
    apartmentDesc: "Escolha quais planos de tarifa o hóspede vê, qual é o padrão e a ordem",
    loading: "Carregando tarifas…",
    emptyApartment: "Nenhuma tarifa configurada para esta propriedade.",
    emptyHotel: "Nenhum tipo de quarto configurado para este hotel.",
    emptyRoom: "Nenhuma tarifa configurada para este quarto.",
    colTarifa: "Tarifa",
    colVisibleName: "Nome de exibição",
    visibleNameTooltip: "Nome opcional para mostrar ao hóspede",
    namePlaceholderApartment: "ex.: Não reembolsável / Flexível",
    namePlaceholderHotel: "ex.: Café da manhã incluído",
    derivedBadge: "Derivada",
    rulesApartment: "Regras: pelo menos 1 visível e 1 padrão (que deve estar visível).",
    rulesHotel: "Cada quarto deve ter pelo menos 1 tarifa visível e 1 padrão.",
  },
  rooms: {
    ratesCount: "{count} tarifa | {count} tarifas",
    meta: "Capacidade: {capacity} • Adultos: {adults} • Crianças: {children}",
  },
  promotions: {
    title: "Promoções na Reserva Direta",
    desc: "Controle quais são exibidas, se aplicam automaticamente e a ordem.",
    loading: "Carregando promoções…",
    empty: "Nenhuma promoção configurada para esta propriedade.",
    colPromo: "Promoção",
    colBadge: "Selo",
    badgeTooltip: "Texto curto (ex.: -10%, Oferta, Reserva Antecipada).",
    colAuto: "Aplicar automaticamente",
    colStackable: "Acumulável",
    badgePlaceholder: "ex.: -10% / Oferta",
    tip: "Dica: se você não quiser que uma promoção afete o preço final, desative “Aplicar automaticamente” e mantenha-a visível.",
    fromDate: "A partir de {date}",
    untilDate: "Até {date}",
  },
  addons: {
    loading: "Carregando configurações…",
    subtabOccupancy: "Desconto por ocupação",
    subtabExtraGuest: "Cobrança por hóspede adicional",
    baseOccupancyTitle: "Ocupação base",
    baseOccupancyDesc: "O preço habitual corresponde a esta ocupação. Para menos hóspedes, você aplica uma redução.",
    guestsLabel: "hóspedes",
    headOccupancy: "Ocupação",
    headRule: "Regra",
    headValue: "Valor",
    headActive: "Ativo",
    guestWord: "hóspede | hóspedes",
    usualPrice: "Preço habitual",
    modePercent: "Redução %",
    modeFixed: "Redução fixa (por noite)",
    occupancyExample: "Exemplo: base de 4 hóspedes e descontos para 3, 2 e 1.",
    configTitle: "Configurações",
    configDesc: "Aplique um acréscimo para cada hóspede adicional acima da ocupação incluída.",
    activate: "Ativar",
    includedTitle: "Ocupação incluída",
    includedDesc: "Obtida automaticamente da capacidade da acomodação.",
    maxExtraLabel: "Máximo de hóspedes adicionais permitidos",
    maxHelpHtml: "Quantos hóspedes podem ser adicionados <b>além da ocupação incluída</b>.<br />Se você definir <b>0</b>, nenhum hóspede adicional é permitido.<br />Se deixar em branco, não há limite.",
    chargeTypeLabel: "Tipo de cobrança",
    chargeTypeFixed: "Valor fixo",
    chargeTypePercentage: "Porcentagem",
    chargeTypeHelp: "Fixo: {currency} por hóspede adicional. Porcentagem: % do preço base.",
    priceLabel: "Preço por hóspede adicional",
    appliesHelp: "Aplicado por hóspede adicional.",
    appliesBlockedNote: "(Nenhum hóspede adicional permitido quando o máximo é 0)",
    applicationLabel: "Aplicação",
    applicationNote: "Por enquanto, esta cobrança se aplica por noite.",
    previewFixed: "Cada hóspede adicional acrescenta <b>{amount}</b> por noite.",
    previewPercent: "Cada hóspede adicional acrescenta <b>{percent}%</b> do preço base por noite.",
    singleValueNote: "Este é um <b>valor único</b> (ex.: +10 {currency} ou +15% por hóspede adicional).",
  },
  payments: {
    title: "Preços e pagamentos",
    desc: "Tipo de cobrança e descontos para reservas diretas.",
    paymentTypeTitle: "Tipo de pagamento",
    onArrivalLabel: "Pagar na chegada",
    onArrivalDesc: "O hóspede reserva e paga diretamente na chegada.",
    onlineLabel: "Pagamento online",
    onlineDesc: "O hóspede paga online ao concluir a reserva.",
    discountsTitle: "Descontos",
    enableDiscount: "Ativar desconto em reservas diretas",
    discountTypeTitle: "Tipo de desconto",
    typePercentage: "Porcentagem",
    typePercentageDesc: "Desconto proporcional ao total.",
    typeFixed: "Fixo",
    typeFixedDesc: "Valor fixo a deduzir.",
    valueTitle: "Valor",
    placeholderPercentage: "ex.: 10",
    placeholderFixed: "ex.: 15,00",
    helpPercentage: "Máximo de 100%. Aplicado ao total.",
    helpFixed: "Um valor fixo é deduzido em {currency}.",
    previewPercentage: "Um desconto de {percent}% será aplicado.",
    previewFixed: "Um desconto de {amount} será aplicado.",
  },
  share: {
    title: "Compartilhar",
    desc: "Copie o link de reserva direta e compartilhe no WhatsApp ou abra a visualização do hóspede.",
    linkLabel: "Link de reserva",
    linkHelp: "Este é o link que você compartilha com os hóspedes.",
    viewAsGuest: "Ver como hóspede",
    tip: "Dica: compartilhe este link na sua bio, mensagens automáticas e campanhas.",
    whatsappMessage: "Olá 👋 Aqui está o link para reservar: {link}",
  },
  errors: {
    loadRatePlans: "Não foi possível carregar as tarifas.",
    saveRatePlans: "Não foi possível salvar as tarifas.",
    roomMinVisible: 'O quarto "{name}" deve ter pelo menos 1 tarifa visível.',
    roomExactlyOneDefault: 'O quarto "{name}" deve ter exatamente 1 tarifa padrão.',
    roomDefaultMustBeVisible: 'Em "{name}", a tarifa padrão deve estar visível.',
    aptMinVisible: "Você deve manter pelo menos 1 tarifa visível.",
    aptExactlyOneDefault: "Deve haver exatamente 1 tarifa padrão.",
    aptDefaultMustBeVisible: "A tarifa padrão deve estar visível.",
    loadPromotions: "Não foi possível carregar as promoções.",
    savePromotions: "Não foi possível salvar as promoções.",
    saveAddons: "Não foi possível salvar as cobranças adicionais.",
    maxExtraRange: "O máximo de hóspedes adicionais deve estar entre 0 e 50 (ou vazio = sem limite).",
    extraPriceInvalid: "O preço por hóspede adicional deve ser válido (>= 0).",
    percentRange: "A porcentagem deve estar entre 0 e 100.",
    baseOccupancyRange: "A ocupação base deve estar entre 1 e {max}.",
    discountValuesInvalid: "Os valores de desconto devem ser números válidos (>= 0).",
    discountPercentMax: "Descontos percentuais não podem exceder 100.",
    updateFailed: "Não foi possível atualizar.",
    updateUnitFailed: "Não foi possível atualizar o status da unidade.",
    updateGlobalFailed: "Não foi possível atualizar o status global.",
    noLinkCopy: "Nenhum link para copiar.",
    copyFailed: "Não foi possível copiar o link.",
    noLinkShare: "Nenhum link para compartilhar.",
    noLinkOpen: "Nenhum link para abrir.",
    updatePaymentType: "Não foi possível atualizar o tipo de pagamento.",
    savePayments: "Não foi possível salvar as alterações.",
  },
  success: {
    ratePlansSaved: "Tarifas salvas com sucesso.",
    promotionsSaved: "Promoções salvas com sucesso.",
    addonsSaved: "Cobranças adicionais salvas com sucesso.",
    updated: "Atualizado com sucesso.",
    globalUpdated: "Status global atualizado.",
    linkCopied: "Link copiado.",
    changesSaved: "Alterações salvas.",
  },
};
